<template>
  <div class="element el-image" :class="{ 'can-change': is_editable }">
    <div ref="img" class="img-wrapper">
      <div
        class="img"
        :style="{
          backgroundImage: 'url(' + value + query_token + ')',
          height: max_height,
          transform: `translate(${
            dragging ? tmp_image_offset.x : image_offset.x
          }px, ${
            dragging ? tmp_image_offset.y : image_offset.y
          }px) rotate(${image_rotation}deg) scale(${image_zoom})`,
        }"
      ></div>
    </div>
    <div
      v-if="is_editable && value"
      class="img-edit-buttons"
      :class="[`img-edit-buttons--${edition_position}`]"
    >
      <div v-if="editingImage" class="btn-option-wrapper">
        <q-btn
          key="closeEditingImage"
          class="btn-option btn"
          color="white"
          text-color="green"
          icon="close"
          @click="editingImage = false"
          size="8px"
        />
      </div>
      <template v-else>
        <div class="btn-option-wrapper">
          <q-btn
            class="btn-option btn"
            color="white"
            text-color="green"
            icon="pan_tool"
            @click="editingImage = true"
            size="8px"
          />
        </div>
        <div class="btn-option-wrapper">
          <q-btn
            class="btn-option btn"
            color="white"
            text-color="green"
            icon="rotate_right"
            @click="rotate()"
            size="8px"
          />
        </div>
        <div class="btn-option-wrapper">
          <q-btn
            class="btn-option btn"
            color="white"
            text-color="green"
            icon="zoom_in"
            @click="zoom(0.1)"
            size="8px"
          />
        </div>
        <div class="btn-option-wrapper">
          <q-btn
            class="btn-option btn"
            color="white"
            text-color="green"
            icon="zoom_out"
            @click="zoom(-0.1)"
            size="8px"
          />
        </div>
        <div class="btn-option-wrapper">
          <q-btn
            class="btn-option btn"
            color="white"
            text-color="green"
            icon="delete"
            @click="deleteImage()"
            size="8px"
          />
        </div>
      </template>
    </div>
    <form v-if="is_editable && !editingImage" class="form-upload">
      <div class="notification" v-if="notification">
        {{ notification }}
      </div>
      <div class="loader-container" v-if="uploading">
        <icon file="loader" :size="24" class="rotate" />
      </div>
      <div
        class="dropbox"
        :class="{ uploading: uploading }"
        @drop.prevent="addFile"
        @dragover.prevent
        @click="show_upload_box()"
      >
        <input type="file" ref="upload_box" @change="handle_file_upload()" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import $ from "jquery";
import { setTimeout } from "timers";

export default {
	name: "el-image",
	mixins: [ElementMixin],
	props: {
		upload: { type: Boolean, default: false },
		max_height: { type: String, default: "100px" },
		edition_position: { type: String, default: "stacked" },
	},
	data () {
		return {
			image_file: "",
			notification: undefined,
			uploading: false,
			editingImage: false,
			dragging: false,
			image_offset: { x: 0, y: 0 },
			image_zoom: 1,
			image_rotation: 0,
			start_drag_offset: { x: 0, y: 0 },
			last_drag_offset: { x: 0, y: 0 },
		};
	},
	computed: {
		...mapGetters(["app_parameters", "user"]),
		tmp_image_offset () {
			return {
				x:
          this.image_offset.x +
          (this.last_drag_offset.x - this.start_drag_offset.x),
				y:
          this.image_offset.y +
          (this.last_drag_offset.y - this.start_drag_offset.y),
			};
		},
    query_token () {
      return "?token="+this.user.token;
    }
	},
	created () {
		if (this.parent_data.image_offset) {
			this.image_offset = this.parent_data.image_offset;
		}

		if (this.parent_data.image_zoom) {
			this.image_zoom = this.parent_data.image_zoom;
		}

		if (this.parent_data.image_rotation) {
			this.image_rotation = this.parent_data.image_rotation;
		}
	},
	mounted () {
		this.$refs.img.addEventListener("mousedown", this.onStartDrag);
		this.$refs.img.addEventListener("mousemove", this.onDrag);
		this.$refs.img.addEventListener("mouseup", this.onEndDrag);
	},
	beforeDestroy () {
		this.$refs.img.removeEventListener("mousedown", this.onStartDrag);
		this.$refs.img.removeEventListener("mousemove", this.onDrag);
		this.$refs.img.removeEventListener("mouseup", this.onEndDrag);
	},
	methods: {
		addFile: async function (e) {
			// console.log('add file');
			const droppedFiles = e.dataTransfer.files;
			if (!droppedFiles) return;
			this.image_file = droppedFiles[0];
			if (!this.check_file_type()) {
				return;
			}
			this.uploading = true;
			await this.$store.dispatch("upload_file", {
				the_file: this.image_file,
				parent_data: this.parent_data,
				property: this.property,
			});
			this.uploading = false;
		},
		show_upload_box: function () {
			$(this.$refs.upload_box).click();
		},
		handle_file_upload: async function () {
			const input = this.$refs.upload_box;
			if (input.files && input.files[0]) {
				this.image_file = input.files[0];
				if (!this.check_file_type()) {
					return;
				}
				this.uploading = true;
				// console.log("image_file", this.image_file);
				await this.$store.dispatch("upload_file", {
					the_file: this.image_file,
					parent_data: this.parent_data,
					property: this.property,
				});
				// console.log(response)
				this.uploading = false;
			}
		},

		check_file_type: function () {
			const extension = this.image_file.name.toUpperCase().split(".").pop();
			const authorizedExtensions = this.app_parameters.authorized_image_formats;
			if (authorizedExtensions.indexOf(extension) == -1) {
				// console.log('error - file extension not authorized')
				let message =
          "Les extensions acceptées pour les images sont les suivantes : ";
				authorizedExtensions.forEach((ext, i) => {
					message += ext + (i < authorizedExtensions.length - 1 ? ", " : "");
				});
				// afficher le message
				this.notification = message;
				const self = this;
				setTimeout(function () {
					self.notification = undefined;
				}, 5000);
				return false;
			} else {
				return true;
			}
		},
		onStartDrag (e) {
			if (this.is_editable) {
				this.dragging = true;
				this.start_drag_offset = this.last_drag_offset = {
					x: e.offsetX,
					y: e.offsetY,
				};
			}
		},
		onDrag (e) {
			if (this.dragging && this.is_editable) {
				//console.log({ x: e.offsetX, y: e.offsetY });
				this.last_drag_offset = { x: e.offsetX, y: e.offsetY };
			}
		},
		onEndDrag () {
			if (this.is_editable) {
				this.image_offset = this.tmp_image_offset;
				this.dragging = false;
				// this.parent_data.image_offset = this.image_offset

				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: "image_offset",
					value: this.image_offset,
				});
			}
		},
		zoom (offset = 0.1) {
			if (this.is_editable) {
				this.image_zoom += offset;

				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: "image_zoom",
					value: this.image_zoom,
				});
			}
		},
		rotate (offset = 90) {
			if (this.is_editable) {
				this.image_rotation += offset;

				if (Math.abs(this.image_rotation) === 360) this.image_rotation = 0;

				this.$store.dispatch("edit_object", {
					obj: this.parent_data,
					field: "image_rotation",
					value: this.image_rotation,
				});
			}
		},
		deleteImage () {
			this.image_file="";
			this.image_zoom=1;
			this.image_offset={ x: 0, y: 0 };
			this.image_rotation=0;
			this.$store.dispatch("edit_object", {
				obj: this.parent_data,
				field: "src",
				value: "",
			});
			this.$store.dispatch("edit_object", {
				obj: this.parent_data,
				field: "image_zoom",
				value: 1,
			});
			this.$store.dispatch("edit_object", {
				obj: this.parent_data,
				field: "image_rotation",
				value: 0,
			});
			this.$store.dispatch("edit_object", {
				obj: this.parent_data,
				field: "image_offset",
				value: { x: 0, y: 0 },
			});
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';

.el-image {
  .img-wrapper {
    background-color: #eee;
    overflow: hidden;
  }

  &.can-change .img-wrapper {
    cursor: move;
  }

  .img {
    display: block;
    width: 100%;
    height: 100px;
    overflow: hidden;
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    pointer-events: none;
    background-size: contain;
  }

  >>> .q-btn__wrapper {
    padding-left: 0 !important;
    padding-right: 10px !important;
  }

  .img-edit-buttons {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 100;

    .btn-option-wrapper {
      padding-right: 2px;
    }

    &--right {
      width: 88px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      left: auto;
      top: 0;
      right: -10px;
      transform: translateX(100%);

      .btn-option-wrapper {
        padding-right: 5px;
        padding-bottom: 5px;
        flex: 50%;
      }
    }

    &--top {
      display: flex;
      flex-direction: row;
      left: auto;
      top: -10px;
      left: 0;
      transform: translateY(-100%);

      .btn-option {
        margin-bottom: 0;
      }
    }
  }

  .form-upload {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    .dropbox {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border: 2px dashed purple;
      background-color: alpha(purple, 15%);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        border-color: purple;
        background-color: alpha(purple, 25%);

        &:before {
          background-color: purple;
        }
      }

      &:before {
        content: 'Glisser une photo ici';
        text-transform: uppercase;
        font-weight: 600;
        background-color: lighten(purple, 15%);
        color: #fff;
        padding: 8px 12px;
      }

      &.uploading {
        &:before {
          content: none;
        }
      }
    }

    .notification {
      position: absolute;
      max-width: 100%;
      bottom: 0px;
      left: 0px;
      right: 0px;
      text-align: center;
      z-index: 100;
    }

    input {
      position: absolute;
      top: 0;
      left: 10000px;
      opacity: 0;
    }

    .loader-container {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: lighten(purple, 15%);
      color: #fff;
      width: fit-content;
      padding: 8px 12px;

      .icon.rotate {
        animation: rotate 1.25s infinite linear;
      }
    }
  }
}
</style>